import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react'
import Results, { ResultItem } from '../Symbols/Results';

const formatCurrency = amount => {
	return Math.round(amount).toLocaleString('cs') + ' Kč';
};

const ResultNumber = styled('span')`
	font-style: italic;
	text-align: right;
`;

const Total = css`
	font-size: 18px;
	font-weight: bold;

	${ResultNumber} {
		color: #ca372c;
	}
`;

export default function StyledResult({ childallowance }) {
	return (
		<Results data-cy="result">
			<ResultItem name="Máte nárok na přídavky na dítě?">
				<ResultNumber>{childallowance.isAllowed ? 'Ano' : 'Ne'}</ResultNumber>
			</ResultItem>
			<ResultItem name="Jaké je životní minimum rodiny">
				<ResultNumber>{formatCurrency(childallowance.livingMinimum)}</ResultNumber>
			</ResultItem>
			<ResultItem name="Kolik budou přídavky na dítě" css={Total}>
				<ResultNumber>{formatCurrency(childallowance.total)}</ResultNumber>
			</ResultItem>
		</Results>
	);
}
